import { useState, useCallback } from "react";
import { SessionClosed } from "../SessionClosed";

export const useSessionClosed = (title: string, message: string) => {

	const [promise, setPromise] = useState(null);

	const close = useCallback(() => new Promise((resolve, reject) => {
        setPromise({ resolve });
    }), []);

    const handleClose = () => {
        setPromise(null);
    };
    const handleCancel = () => {
        promise?.resolve(false);
        handleClose();
    };
    const DialogSessionClosed = (): JSX.Element => {
        return <>
            <SessionClosed
                onClose={handleCancel}
                open={promise !== null}
                title={title}
                message={message}
            />
        </>
    };

    return { DialogSessionClosed, close };
}